import * as React from "react"
import { graphql } from 'gatsby'
import loadable from "@loadable/component"

import Layout from "../components/layout"
import HomeBanner from "../components/HomeBanner/HomeBanner"
import LandingBanner from "../components/LandingBanner/LandingBanner"
import FAQ from "../components/FAQ/FAQ"
import OfficeSlider from "../components/OfficeSlider/OfficeSlider"
import FindSolution from "../components/FindSolution/FindSolution"
import AboutSpaces from "../components/AboutSpaces/AboutSpaces"
import SpaceFeatures from "../components/SpaceFeatures/SpaceFeatures"
import Seo from "../components/seo"
const OurLocations = loadable(() => import("../components/OurLocations/OurLocations"))
const Guidance = loadable(() => import("../components/Guidance/Guidance"))
const InsightsDesc = loadable(() => import("../components/InsightsDesc/InsightsDesc"))
const SolutionsDesc = loadable(() => import("../components/SolutionsDesc/SolutionsDesc"))
const LandingContent = loadable(() => import("../components/SolutionsContent/LandingContent"))
const LandingBgColorSection = loadable(() => import("../components/AvailableSpaces/LandingBgColorSection"))
const TeamDesc = loadable(() => import("../components/TeamDesc/TeamDesc"))
const TeamSlider = loadable(() => import("../components/TeamSlider/TeamSlider"))
const Stats = loadable(() => import("../components/Stats/Stats"))
const Quotes = loadable(() => import("../components/Quotes/Quotes"))
const VideoModule = loadable(() => import("../components/VideoModule/VideoModule"))

const LandingPageTemplate = ({ data }, props) => {
    const PageData = data?.strapiPage
    return (
        <Layout>
            {PageData?.banner && PageData.banner.images && PageData.banner.images.length > 1 ? <HomeBanner {...PageData.banner} id={PageData.strapi_id} imagetransforms={PageData.ggfx_results} /> : PageData?.banner && PageData.banner.images && PageData.banner.images.length === 1 ? <LandingBanner {...PageData.banner} id={PageData.strapi_id} imagetransforms={PageData.ggfx_results} /> : ""}

            <div id="landing-section">
                {PageData?.add_page_modules?.length > 0 && PageData.add_page_modules?.map((module, index) => {
                    return (
                        <>
                            {module.strapi_component === "page-modules.review" && <Quotes {...module} />}
                            {module.strapi_component === "page-modules.stats" && <Stats pagedata={module} />}
                            {module.strapi_component === "page-modules.global-module" && module.select_module === "team_slider" && <TeamSlider pagedata={module} />}
                            {module.strapi_component === "page-modules.global-module" && module.select_module === "locations" && <OurLocations data={module} />}
                            {module.strapi_component === "page-modules.global-module" && module.select_module === "insights" && <InsightsDesc data={module} />}
                            {module.strapi_component === "page-modules.global-module" && module.select_module === "solutions" && <SolutionsDesc data={module} />}
                            {module.strapi_component === "page-modules.global-module" && module.select_module === "team" && <TeamDesc data={module} />}
                            {module.strapi_component === "page-modules.services" && module.layout === "steps" && <FindSolution data={module} />}
                            {module.strapi_component === "page-modules.services" && module.layout === "services" && <SpaceFeatures data={module} />}
                            {module.strapi_component === "page-modules.image-and-content" && module.add_image?.length > 1 ? <AboutSpaces id={PageData.strapi_id} imagetransforms={PageData.ggfx_results} {...module} /> : module.strapi_component === "page-modules.image-and-content" && module.add_image?.length === 1 && module.background_color_transparent ? <LandingContent id={PageData.strapi_id} imagetransforms={PageData.ggfx_results} {...module} /> : module.strapi_component === "page-modules.image-and-content" && module.add_image?.length === 1 && !module.background_color_transparent ? <LandingBgColorSection id={PageData.strapi_id} imagetransforms={PageData.ggfx_results} {...module} /> : ""}
                            {module.strapi_component === "page-modules.images-and-video" && <VideoModule {...module} />}
                            {/* {module.strapi_component === "page-modules.accordion" && <FAQ {...module} />} */}
                        </>
                    )
                })}
            </div>
            {PageData?.footer_module && <Guidance {...PageData?.footer_module} />}
        </Layout>
    )
}

/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export const Head = ({ data }) => {
    const PageData = data?.strapiPage
    return (
        <Seo
            title={PageData?.seo?.metaTitle ? PageData?.seo?.metaTitle : PageData?.title}
            description={PageData?.seo?.metaDescription ? PageData?.seo?.metaDescription : PageData?.title}
        />
    )
}

export default LandingPageTemplate


export const query = graphql`
  query ($page_id: String) {
    strapiPage(id: {eq: $page_id}) {
        ...PageFragment
        add_page_modules {
            ... on STRAPI__COMPONENT_PAGE_MODULES_GLOBAL_MODULE {
              ...GlobalModuleFragment
            }
            ... on STRAPI__COMPONENT_PAGE_MODULES_SERVICES {
                ...ServicesModuleFragment
            }
            ... on STRAPI__COMPONENT_PAGE_MODULES_IMAGE_AND_CONTENT {
                ...ImageContentModuleFragment
            }
            ... on STRAPI__COMPONENT_PAGE_MODULES_ACCORDION {
                ...FAQModuleFragment
            }
            ... on STRAPI__COMPONENT_PAGE_MODULES_STATS {
                strapi_component
                add_stats {
                  title
                  content
                }
            }
            ... on STRAPI__COMPONENT_PAGE_MODULES_REVIEW {
              strapi_component
              select_review {
                company
                review
                name
              }
            }
            ... on STRAPI__COMPONENT_PAGE_MODULES_IMAGES_AND_VIDEO {
                strapi_component
                video_url
            }
        }
    }
  }
`